import type { AxiosInstance } from 'axios';
import type { EntityId, InspectionCheck } from '@/types';

import { getInspectionChecks } from '@/actions/inspectionCheck';

function sortInspectionCheckRows(rows: InspectionCheck[]): InspectionCheck[] {
  return [...rows].sort((a, b) => {
    const a_section = a.check_section || '';
    const b_section = b.check_section || '';
    if (a_section === b_section) {
      const a_name = a.check_name || a.name || '';
      const b_name = b.check_name || b.name || '';
      return a_name > b_name ? 1 : a_name < b_name ? -1 : 0;
    }
    if (a_section === 'global') {
      return -1;
    }
    if (b_section === 'global') {
      return 1;
    }
    return a_section > b_section ? 1 : a_section < b_section ? -1 : 0;
  });
}

/**
 * Loads every inspection check row for one manifest (and optional document) by paging with limit 100.
 */
export async function fetchAllInspectionChecksForManifest(
  api: AxiosInstance,
  inspection_id: EntityId,
  document_entity_id: EntityId | undefined,
  manifest_id: EntityId,
): Promise<InspectionCheck[]> {
  const page_limit = 100;
  let start_key: string | undefined;
  const aggregated: InspectionCheck[] = [];

  for (;;) {
    const pack = await getInspectionChecks(
      api,
      inspection_id,
      document_entity_id,
      manifest_id,
      page_limit,
      start_key,
    );
    const batch = pack.results || [];
    aggregated.push(...batch);
    if (!pack.last_key) {
      break;
    }
    start_key = pack.last_key;
  }

  return sortInspectionCheckRows(aggregated);
}
